<div class="flex flex-col h-full w-full pb-8 ">
  <!-- Logo + Close -->
  <div class="flex justify-between items-center p-2 h-auto">
    <!-- Logo -->
    <div class="w-30 h-auto">
        <img class="w-90 h-auto" src="images/logo/logo.svg" />
    </div>

    <!-- Close button -->
    <button mat-icon-button mat-dialog-close (click)="closeDialog()" class="icon-size-2" *ngIf="shouldShowCloseButton()">
        <mat-icon>close</mat-icon>
    </button>
    
  </div>

  <!-- Title -->
  <div class="text-center mb-6">
    <h1 class="text-3xl font-dm font-semibold text-ferrerText">{{'register.title' | transloco}}</h1>
    <p class="text-base font-dm text-ferrerSecondary mt-1">{{'register.emailVerified' | transloco}}</p>
    
  </div>

<!--div form group-->
<div class="mt-3 mb-6 pb-6">
  <!-- Form Fields -->
  <form class="space-y-6 mt-2 mb-2" [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
    
    
    
    <!-- Password -->
<div class="relative mb-1 floating-label password-field flex flex-col flex-grow">
  <input 
    type="password"
    required
    formControlName="password"
    id="regpassword" 
    placeholder="Crea tu contraseña (obligatorio)" 
    #regpassword
    class="placeholder-base h-14 text-base md:text-sm w-full border border-ferrerSecondary rounded-2xl px-4 py-4 pr-12 focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
    [ngClass]="{'border-red-500': registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched}" 
  />
  <label for="regpassword" class="floating-label">{{'register.emailVerified_PasswordCreation' | transloco}}</label>
  <button
      mat-icon-button
      type="button"
      class="toggle-password absolute"
      (click)="
      regpassword.type === 'password'
              ? (regpassword.type = 'text')
              : (regpassword.type = 'password')
      "
      matSuffix
  >
      @if (regpassword.type === 'password') {
         <mat-icon
              class="icon-size-5"
              [svgIcon]="'heroicons_solid:eye'"
          ></mat-icon>
      }
      @if (regpassword.type === 'text') {
         <mat-icon
              class="icon-size-5"
              [svgIcon]="'heroicons_solid:eye-slash'"
          ></mat-icon>
      }
  </button>
  <p *ngIf="!registrationForm.get('password')?.invalid || !registrationForm.get('password')?.touched" class="text-base md:text-base text-gray-400 mt-2 ml-1">{{'register.emailVerified_PasswordTip' | transloco}}</p>
  <!-- Error messages -->
      <div *ngIf="registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched" class="text-base text-red-500 mt-1 ml-2 flex items-center">
        <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
        <div *ngIf="registrationForm.get('password')?.errors?.['required']">
          {{'validations.passwordRequired' | transloco}}
        </div>
        <div *ngIf="registrationForm.get('password')?.errors?.['minlength']">
          {{'validations.passwordLength' | transloco}}
        </div>
        <div *ngIf="registrationForm.get('password')?.errors?.['maxlength']">
          {{'validations.passwordLength' | transloco}}
        </div>
      </div>
    </div>


    <hr class="my-6" />
    
    
    <div class="space-y-5 text-base md:text-base text-gray-700">
      
      <!-- Main Consent with Sub-consents -->
      <div class="mb-1">
        <ul class="space-y-4 w-full">
          <!-- Main consent checkbox -->
          
          <li *ngIf="subConsentsFormArray.controls.length > 0" class="flex items-start space-x-2">
            <div class="custom-checkbox-container mt-1">
              <input
                type="checkbox"
                id="mainConsent"
                formControlName="mainConsent"
                class="custom-checkbox visually-hidden"
                [ngClass]="{'is-invalid': registrationForm.get('mainConsent')?.invalid && registrationForm.get('mainConsent')?.touched}"
                (change)="onMainConsentChange()"
                [disabled]="anySubConsentChecked"
              />
              <label for="mainConsent" class="custom-checkbox-label"></label>
            </div>
            <div class="flex flex-col">
              <label for="mainConsent" class="text-base md:text-base font-semibold">
                {{ 'registerPlaceholders.mainCheckboxText' | transloco }}
              </label>
              <span class="text-sm md:text-sm">
                {{ 'registerPlaceholders.mainCheckboxmMainText' | transloco }}
              </span>
            </div>
          </li>

          <!-- Sub-consents (always visible) -->
          <div *ngIf="subConsentsFormArray.controls.length > 0">
          <div formArrayName="subConsents">
            <div *ngFor="let control of subConsentsFormArray.controls; let i = index" class="mt-4">
            <li class="ml-6 flex items-start space-x-2 mt-4">
              <div [formGroupName]="i" class="custom-checkbox-container">
                <input
                  type="checkbox"
                  [id]="'subConsent' + i"
                  formControlName="checked"
                  class="custom-checkbox visually-hidden"
                  (change)="onSubConsentChange()"
                  [disabled]="registrationForm.get('mainConsent')?.value"
                />
                <label [for]="'subConsent' + i" class="custom-checkbox-label"></label>
              </div>
              <div class="flex flex-col">
                
                <span class="text-sm md:text-sm">
                  {{ control.get('content')?.value }}
                </span>
              </div>
            </li>
            </div>
          </div>
          </div>
        </ul>

        <!-- Validation error message -->
        <div *ngIf="registrationForm.get('mainConsent')?.invalid && registrationForm.get('mainConsent')?.touched" class="text-base text-red-500 mt-1 ml-2 flex items-center">
          <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
          <div *ngIf="registrationForm.get('mainConsent')?.errors?.['required']">
            {{'validations.requiredConsent' | transloco}}
          </div>
        </div>
        <div *ngIf="subConsentsFormArray.controls.length > 0">
          <hr class="my-6" />
        </div>
      </div>

      <!-- Terms Consent -->
      <!-- Terms Consent -->
      <div class="mb-1">
        <div class="flex items-start space-x-3">
          <div class="custom-checkbox-container mt-1 flex-shrink-0">
            <input
              type="checkbox"
              id="termsConsent"
              formControlName="termsConsent"
              class="custom-checkbox visually-hidden"
              [ngClass]="{'is-invalid': registrationForm.get('termsConsent')?.invalid && registrationForm.get('termsConsent')?.touched}"
            />
            <label for="termsConsent" class="custom-checkbox-label"></label>
          </div>
          <label for="termsConsent" class="cursor-pointer">
            <span>{{'register.termsprivacyMainText' | transloco}} <a (click)="goToTermsStep()" class="text-[#006E75] hover:text-[#003E42] underline hover:underline cursor-pointer">{{'register.termsanchourButton' | transloco}}</a> {{'general.termslink' | transloco}} <a (click)="gotoUserPrivacyStep()" class="text-[#006E75] hover:text-[#003E42] underline hover:underline cursor-pointer">{{'register.userprivacyanchourButton' | transloco}}</a></span><br />
            <div *ngIf="registrationForm.get('termsConsent')?.invalid && registrationForm.get('termsConsent')?.touched" class="text-base text-red-500 mt-1 flex items-center">
              <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
              <div *ngIf="registrationForm.get('termsConsent')?.errors?.['required']">
                {{'validations.consentMissing' | transloco}}
              </div>
            </div>
            <div class="text-sm md:text-sm" [innerHTML]="protectionInformation"></div>
          </label>
        </div>
        
      </div>
      <!-- consent special data processing with hand icon-->
<div *ngIf="showSpecialDataProcessingField()" class="mb-1">
  <label class="flex items-start space-x-3">
    <div class="custom-checkbox-container mt-1">
      <input
        type="checkbox"
        id="ConsentSpecialDataProcessing"
        formControlName="ConsentSpecialDataProcessing"
        class="custom-checkbox visually-hidden"
        [ngClass]="{'is-invalid': registrationForm.get('ConsentSpecialDataProcessing')?.invalid && registrationForm.get('ConsentSpecialDataProcessing')?.touched}"
      />
      <label for="ConsentSpecialDataProcessing" class="custom-checkbox-label"></label>
    </div>
    <span [innerHTML]="'register.registerConsentSpecialDataProcessing' | transloco:{grupoFerrerLink: grupoFerrerLinkHtml}">
      
    </span>
  </label>
  <div *ngIf="registrationForm.get('ConsentSpecialDataProcessing')?.invalid && registrationForm.get('ConsentSpecialDataProcessing')?.touched" class="text-base flex items-center text-red-500 mt-1 ml-2">
    <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
    <div *ngIf="registrationForm.get('ConsentSpecialDataProcessing')?.errors?.['required']">
      {{'validations.requiredConsent' | transloco}}
    </div>
  </div>
</div>

      <!--data processing conesnt-->
<div *ngIf="showDataConsentField()" class="mb-1">
        <div class="flex items-start space-x-3">
          <div class="custom-checkbox-container mt-1 flex-shrink-0">
            <input
              type="checkbox"
              id="dataConsent"
              formControlName="dataConsent"
              class="custom-checkbox visually-hidden"
              [ngClass]="{'is-invalid': registrationForm.get('dataConsent')?.invalid && registrationForm.get('dataConsent')?.touched}"
            />
            <label for="dataConsent" class="custom-checkbox-label"></label>
          </div>
          <label for="dataConsent" class="cursor-pointer">
            {{'register.registerdataTreamentMaintext' | transloco}}
          </label>
        </div>
        <div *ngIf="registrationForm.get('dataConsent')?.invalid && registrationForm.get('dataConsent')?.touched" class="text-base text-red-500 mt-1 ml-8 flex items-center">
          <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
          <div *ngIf="registrationForm.get('dataConsent')?.errors?.['required']">
            {{'validations.requiredConsent' | transloco}}
          </div>
        </div>
      </div>
      
    </div>
  </form>
</div>

<div *ngIf="registerApiError" class="w-full max-w-md mt-4 p-3 rounded-md text-red-600 text-base flex items-center justify-center mb-4">
    <mat-icon class="mr-2 text-red-500 icon-size-5">error_outline</mat-icon>
    <span>{{ registerApiError }}</span>
</div>
<!-- Submit Button -->
<button 
  type="submit" 
  (click)="onSubmit()"
  class="w-full my-button mb-8 bg-teal-700 hover:bg-teal-800 text-white py-4 rounded-full text-base md:text-sm font-semibold shadow transition h-14"
>
  <div class="flex items-center justify-center">
  <span *ngIf="!isSubmitting">{{'register.registerVerifiedButton' | transloco}}</span>
  <svg *ngIf="!isSubmitting" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor">
    <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H7a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
  </svg>
  <div *ngIf="isSubmitting" class="flex justify-center items-center">
    <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    <span class="ml-2">{{'general.processing' | transloco}}</span>
  </div>
  </div>
</button>


</div>